import ApiService from "../apiService";
import { get, patch, post, destroy } from "../apiService";
const _ = require("lodash");
const model = "programs";

export default class ProgramService extends ApiService {
  findAll(searchTerm) {
    return get(`/${model}`, {
      params: {
        include: "programSummary",
        "filter[search]": searchTerm
      }
    });
  }

  find(id) {
    return get(`/${model}/${id}`, {
      params: {
        include: "programSummary,programItem.task,user"
      }
    });
  }

  duplicate(item) {
    return post(`/${model}/${item.id}/duplicate`, item);
  }

  save(item) {
    delete item.attributes["author"];
    delete item["programItem"];
    delete item["relationships"];
    delete item["user"];
    return this.baseSave(model, item);
  }

  archive(item) {
    return this.baseArchive(model, item);
  }

  saveProgramItem(programItem) {
    var itemToSave = _.cloneDeep(programItem);

    delete itemToSave.task;
    delete itemToSave.program;
    delete itemToSave.attributes.totalDays;

    itemToSave.relationships.program = {
      data: {
        id: "" + programItem.attributes.programId,
        type: "programs"
      }
    };

    itemToSave.relationships.task = {
      data: {
        id: "" + programItem.attributes.taskId,
        type: "tasks"
      }
    };
    return this.baseSave("program-items", itemToSave);
  }

  archiveProgramItem(programItem) {
    let item = _.cloneDeep(programItem);
    item.relationships.program = {
      data: {
        id: "" + item.attributes.programId,
        type: "programs"
      }
    };

    item.relationships.task = {
      data: {
        id: "" + item.attributes.taskId,
        type: "tasks"
      }
    };
    delete item["task"];
    delete item["program"];
    delete item.attributes["totalDays"];
    delete item.relationships.program["links"];
    delete item.relationships.task["links"];
    return this.baseArchive("program-items", item);
  }
}



// WEBPACK FOOTER //
// ./src/services/programService/index.js